import {Grid, Typography} from '@material-ui/core';
import React from 'react';
import Pic from '../assets/images/404.png';
import {makeStyles} from '@material-ui/core/styles';
import HomeIcon from '@material-ui/icons/Home';
import {Link as RouterLink, useLocation} from 'react-router-dom';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
  },
  picBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pic: {
    width: '65%',
    height: 'auto',
    alignItems: 'center',
    margin: '0 auto',
    justifyContent: 'center',
    '@media (max-width : 700px)': {
      width: '90%',
    },
  },
  eng: {
    color: '#555',
    opacity: '50%',
    fontSize: '25px',
    fontFamily: 'iranSans',
    fontWeight: 'bold',
    marginTop: '12px',
  },
  per: {
    color: '#2383c0',
    fontSize: '30px',
    fontFamily: 'iranSans',
    padding: '10px',
    fontWeight: 'bold',
    textShadow: '1px 2px 4px #aaa',
    '@media (max-width : 700px)': {
      fontSize: '20px',
    },
  },
  goHomeButton: {
    marginTop: theme.spacing(1),
    border: '1px solid #2383c0',
    borderRadius: '50px',
    boxShadow: '2px 2px 4px #aaa',
    '&:hover': {boxShadow: 'none'},
  },
}));

export default function NotFoundError() {
  const classes = useStyles();
  return (
    <Grid className={classes.root}>
      <Grid direction="column" container alignItems={'center'}>
        <Grid item className={classes.picBox}>
          <img src={Pic} alt={'404pic'} className={classes.pic} />
        </Grid>
        <Grid item className={classes.eng}>
          Not Found...!
        </Grid>
        <Grid item>
          <Typography className={classes.per} noWrap>
            صفحه مورد نظر شما یافت نشد!!!
          </Typography>
        </Grid>
        <Grid item>
          <Button
            color="primary"
            component={RouterLink}
            to="/"
            startIcon={<HomeIcon />}
            className={classes.goHomeButton}
          >
            بازگشت به صفحه اصلی
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}
